import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { requestLogin } from '../actions/authentication';
import { getToken } from '../helpers/localStorageCache';
import currentUserSelector from '../selectors/currentUserSelector';
import App from './App';
import BeforeLogin from './BeforeLogin';

const AppGuard = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const jwtToken = getToken('jwtToken');
    const currentUser = useSelector(currentUserSelector);
    
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const handleLogin = data => dispatch(requestLogin(data));

    if (jwtToken || currentUser) {
        return <App />
    }

    return <BeforeLogin handleLogin={handleLogin} />

}

export default AppGuard;